/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardImage from '../../components/card-image'
import { TitleOne, TextBodyOne } from '../../components/text'
import OnDemandBody from '../../static/images/fix/background-service.svg'
import icBroken from '../../static/icons/card-icon/ic-fix-broken.svg'
import icHealth from '../../static/icons/card-icon/ic-fix-health.svg'
import icTemp from '../../static/icons/card-icon/ic-fix-temp.svg'
import icWork from '../../static/icons/card-icon/ic-fix-work.svg'
import { DemandStyle } from './on-demand.styles'

const OnDemand = () => {
  const { t } = useTranslation();

  return (
    <DemandStyle>
      <img src={OnDemandBody} alt="halojasa/on-demand-body" />
      <Grid>
        <Row center="lg">
          <Col sm={12} xs={12} lg={8} className="column-bottom">
            <TitleOne display="block" align="center">
              {t('pageServiceAcJakarta.part44')}
            </TitleOne>
            <div className="top-margin">
              <TextBodyOne display="block" align="center">
                {t('pageServiceAcJakarta.part45')}
              </TextBodyOne>
            </div>
          </Col>
        </Row>
        <Row className="scroll">
          <Col className="scroll-col" sm={6} md={6} xs={6} lg={3}>
            <CardImage
              noFluid
              image={icHealth}
              title=""
              desc={t('pageServiceAcJakarta.part46')}
            ></CardImage>
          </Col>
          <Col className="scroll-col" sm={6} md={6} xs={6} lg={3}>
            <CardImage
              noFluid
              image={icTemp}
              title=""
              desc={t('pageServiceAcJakarta.part47')}
            ></CardImage>
          </Col>
          <Col className="scroll-col" sm={6} md={6} xs={6} lg={3}>
            <CardImage
              noFluid
              image={icBroken}
              title=""
              desc={t('pageServiceAcJakarta.part48')}
            ></CardImage>
          </Col>
          <Col className="scroll-col" sm={6} md={6} xs={6} lg={3}>
            <CardImage
              noFluid
              image={icWork}
              title=""
              desc={t('pageServiceAcJakarta.part49')}
            ></CardImage>
          </Col>
        </Row>
      </Grid>
    </DemandStyle>
  )
}

export default OnDemand
